module.exports = __webpack_public_path__ + "static/media/Developmenticon06@2x.b8b3e6b2.png";